export const randomImagePreviewTheme = {
  color: 'palette.primary.20',
};
